// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__kFI3_","title":"title__2AGgh","article":"article__2KotD","article-title":"article-title__2qV_K","image":"image__1ihL-"};


//////////////////
// WEBPACK FOOTER
// ./styles/homePage/featured.scss
// module id = 742
// module chunks = 68